module.exports = __webpack_public_path__ + "img/nrsc-main-sm.c78012fe.jpg";